import { Text } from "@fluentui/react";

export const getColor = (props: any) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isFocused) {
    return '#2196f3';
  }
  return '#eeeeee';
};

export const DropzoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

export const DropzoneTextStyled = styled(Text)`
  display: flex;
  color: #bdbdbd;
`;

export const AttachmentListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-top: 10px;
  column-gap: 10px;
  row-gap: 10px;
`;

export const AttachmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #edebe9;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  border-end-start-radius: 12px;
  border-start-start-radius: 12px;
  border-end-end-radius: 12px;
  border-start-end-radius: 12px;
`;

export const AttachmentTextStyled = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  padding-right: 10px;
`;

export const ErrorTextStyled = styled(Text)`
  display: flex;
  padding-top: 5px;
  font-size: 12px;
  font-weight: 400;
  color: #a4262c;
`;

export const deleteButtonStyles = {
  root: {
    margin: '0px 4px',
    size: '8px',
    height: '16px',
    width: '12px',
    color: '#242424',
    justifyContent: 'center',
  },
};